import { Box, Icon, Table, TableCell, TableHeading, Button, Modal, ButtonGroup, Text } from "@nike/eds";
import { Size } from "../../../shared/Types";
import { checkProductExists, findProductByCode, selectSearchTerm, selectSizes } from "../../../shared/store/reducers/OverviewReducer";
import { useDispatch, useSelector } from "react-redux";
import { StoreDispatch } from "../../../shared/store/Store";
import { useEffect, useState } from "react";

type TableComponentProps = {
    onEdit: (size: Size) => void;
    onAdd: (size: Size) => void;
};

export function TableComponent({ onEdit, onAdd }: TableComponentProps) {
    const dispatch: StoreDispatch = useDispatch();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    const sizes: Size[] = useSelector(selectSizes);
    const searchTerm: string = useSelector(selectSearchTerm);

    useEffect(() => {
        dispatch(findProductByCode(searchTerm));
    }, [dispatch, searchTerm]);

    const onAddProductAndSize = async () => {
        const productCode = searchTerm;

        try {
            const exists = await dispatch(checkProductExists(productCode)).unwrap();

            if (exists) {
                onAdd({ productWeightsKey: { productCode } } as Size);
                return;
            }

            setModalMessage(`Product ${productCode} is not available in the Product Master Data.`);
            setIsModalVisible(true);
        } catch (error) {
            setModalMessage('Whoops, something went wrong while checking the product in Product Master data.');
            setIsModalVisible(true);
        }
    };

    if (sizes.length === 0 && searchTerm !== '') {
        return (
            <>
                <Modal
                    onDismiss={() => setIsModalVisible(false)}
                    isOpen={isModalVisible}
                    headerSlot={"Product Not Available"}                   
                >
                    <Text font={"body-1"} as={"p"}>{modalMessage}</Text>
                </Modal>

                <Box mt={100}>
                    <p className="text-center"><Icon name="Search" /></p>
                    <br/>
                    <h2 className="text-center">Product not found</h2>
                    <p className="text-center">Please change the search query to something else or add a new product with size.</p>
                    <br/>
                    <p className="text-center">
                        <Button variant="secondary" beforeSlot={<Icon name="Plus" />} onClick={onAddProductAndSize} size="small">
                            Add product & size
                        </Button>
                    </p>
                </Box>
            </>
        );
    }

    if (sizes.length === 0) {
        return (<Box></Box>);
    }

    const productCode = sizes[0].productWeightsKey.productCode;

    return (
        <Box>
            <Box className="header">
                <h1 className="eds-type--title-2">{productCode}</h1>

                <Button variant="secondary" beforeSlot={<Icon name="Plus" />} onClick={() => onAdd({productWeightsKey: {productCode}} as Size)}>
                    Add new size
                </Button>
            </Box>

            <Box mt={25}>
                <Table isFullWidth={true}>
                    <thead>
                        <tr>
                            <TableHeading>Size</TableHeading>
                            <TableHeading>Weight per unit</TableHeading>
                            <TableHeading></TableHeading>
                        </tr>
                    </thead>
                    <tbody>
                        {sizes.map((size: Size) => (
                            <tr key={'row-' + size.productWeightsKey.size}>
                                <TableCell key={'size-' + size.productWeightsKey.size}>
                                    {size.productWeightsKey.size}
                                </TableCell>
                                <TableCell key={'weight-' + size.productWeightsKey.size}>
                                    {size.grossWeight} {size.weightUnitOfMeasure.toLowerCase()}
                                </TableCell>
                                <TableCell key={'actions-' + size.productWeightsKey.size} alignment="right">
                                    <Button variant="ghost" onClick={() => onEdit(size)}>
                                        <Icon name="Edit" />
                                    </Button>
                                </TableCell>
                            </tr>
                        ))}
                    </tbody>
                </Table> 
            </Box>   
        </Box>   
    )
}